import React__default, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { isNaN } from 'lodash-es';

/* eslint-disable */
function Pagination(_ref) {
  let {
    dataCounts,
    page,
    setPage,
    rowsPerPage = 20,
    pageText,
    pageOfText
  } = _ref;
  const [pageInput, setPageInput] = useState(page);
  const maxPage = Math.ceil(dataCounts / rowsPerPage);
  useEffect(() => {
    setPageInput(page);
  }, [page]);
  function handlePageChange(inputValue) {
    const value = parseInt(inputValue);
    if (value <= 0 || isNaN(value)) {
      return setPageInput(page);
    }
    if (value > 0 && value <= maxPage) {
      return setPage(value);
    }
    if (value > maxPage) {
      setPageInput(maxPage);
      setPage(maxPage);
    }
  }
  const disabledPrev = parseInt(pageInput) === 1;
  const disabledNext = parseInt(pageInput) >= parseInt(maxPage);
  return /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_arrow-left font-size-24",
    style: {
      color: disabledPrev ? '#A5A5A5' : '#7B61FF',
      cursor: disabledPrev ? 'not-allowed' : 'pointer'
    },
    onClick: () => {
      if (disabledPrev) return;
      setPageInput(parseInt(pageInput) - 1);
      setPage(parseInt(pageInput) - 1);
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    color: "#555",
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    mx: "8px"
  }, pageText, /*#__PURE__*/React__default.createElement(Box, {
    component: 'input',
    value: pageInput,
    onChange: e => setPageInput(e.target.value),
    onBlur: () => handlePageChange(pageInput),
    onKeyDown: e => {
      if (e.key === 'Enter') {
        e.target.blur();
      }
    },
    sx: {
      mx: '8px',
      border: '0.5px solid #A5A5A5',
      borderRadius: '4px',
      width: '40px',
      textAlign: 'center',
      height: '24px'
    }
  }), pageOfText, " ", Math.ceil(dataCounts / rowsPerPage)), /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_arrow-right font-size-24",
    style: {
      color: disabledNext ? '#A5A5A5' : '#7B61FF',
      cursor: disabledNext ? 'not-allowed' : 'pointer'
    },
    onClick: () => {
      if (disabledNext) return;
      setPageInput(parseInt(pageInput) + 1);
      setPage(parseInt(pageInput) + 1);
    }
  }));
}
Pagination.propTypes = {
  dataCounts: PropTypes.number,
  page: PropTypes.number,
  setPage: PropTypes.func,
  rowsPerPage: PropTypes.number,
  pageText: PropTypes.string,
  pageOfText: PropTypes.string
};
Pagination.defaultProps = {
  dataCounts: 0,
  page: 1,
  setPage: null,
  rowsPerPage: 20,
  pageText: 'Page',
  pageOfText: 'of'
};
export { Pagination as default };